import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "cultureBreed";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    cultureBreedList: {
      list: [],
      total: 0,
    },
    dialogFormVisible: false,
  },
  actions: {
    //查询养殖品种列表;
    async getCultureBreedData({ commit }, payload) {
      let result = await api.get(
        `/api/Product?${queryString.stringify(payload)}`
      );
      let fiterList = result.data.list.map((item) => {
        if (item.isMain == false) {
          item.isMain = "否";
        } else if (item.isMain == true) {
          item.isMain = "是";
        }
        if (item.canEat == false) {
          item.canEat = "否";
        } else if (item.canEat == true) {
          item.canEat = "是";
        }
        return item;
      });
      if (result.status === 200) {
        commit("setcultureBreedList", result.data);
      }
      return result;
    },
    //删除数据
    async delCultureBreedList(a, payload) {
      let result = await api.delete(`/api/Product/` + payload);
      return result;
    },
    //添加物资
    async addCultureBreed(a, payload) {
      let result = await api.post("/api/Product", payload);
      return result.data;
    },
    //编辑物资
    async editCultureBreed(a, payload) {
      let result = await api.get(`/api/Product/` + payload);
      return result.data;
    },
    //修改
    async updateCultureBreed(a, payload) {
      let result = await api.put(`/api/Product`, payload);
      return result.data;
    },
    //同步鱼苗
    async syncBreed(a, payload) {
      let result = await api.post("/api/Product/SyncFish", payload);
      return result;
    },
  },
  mutations: {
    setcultureBreedList(state, payload) {
      state.cultureBreedList = payload;
    },
    setDialogFormVisibles(state, payload) {
      state.dialogFormVisible = payload;
    },
  },
  getters: {},
});

export default moduleName;
